import { ApiAgentRequest, request } from "../utils/request"
import { useAuthQuery } from "./auth"
import { RawLanguageProficiencyResource } from "@backend/agents-ui-api/resources/student-document/language-proficiency/types"

type GetLanguageProficiencyProps = {
    studentId: string
    languageProficiencyId: string
}

export function useGetLanguageProficiency(props: GetLanguageProficiencyProps) {
    const { data, isLoading, isFetching } = useAuthQuery([
        'language-proficiency',
        props.studentId,
        props.languageProficiencyId,
    ], async () => await getLanguageProficiency(props.studentId, props.languageProficiencyId), {
        enabled: !!props.studentId && !!props.languageProficiencyId,
    })

    return {
        languageProficiencyRecord: data?.data,
        isLoadingLanguageProficiency: isLoading,
        isFetchingLanguageProficiency: isFetching,
    }
}

export async function getLanguageProficiency(studentId?: string, languageProficiencyId?: string) {
    return request<RawLanguageProficiencyResource>(
      new ApiAgentRequest(`/students/${studentId}/language-proficiencies/${languageProficiencyId}`, {
        method: 'GET',
      }),
      {
        isExpectedResponse: (res): res is RawLanguageProficiencyResource => res as boolean,
      },
    )
}